<div class="m-2">
    <h2>Page Not Found</h2>
    <p>Sorry, the page you are looking for does not exist.</p>
</div>